import axios from 'axios';

import {
    KYB_API_BASE_URL
} from '../../../../constants/index';

export default class ComplianceScreeningDashboardService {
    static instance;
    resource = `${KYB_API_BASE_URL}/kyb/compliance-screening/dashboard`;

    static getInstance() {
        if (!ComplianceScreeningDashboardService.instance) {
            ComplianceScreeningDashboardService.instance = new ComplianceScreeningDashboardService();
        }

        return ComplianceScreeningDashboardService.instance;
    }

    async fetchScreeningResults(params = {}) {
        const response = await axios.get(
            `${this.resource}/screening-results`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }
    
    async fetchAIFalsePositives(params = {}) {
        const response = await axios.get(
            `${this.resource}/ai-false-positives`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    async fetchAccuracyAssessment(params = {}) {
        const response = await axios.get(
            `${this.resource}/accuracy-assessment`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    async fetchCategories(params = {}) {
        const response = await axios.get(
            `${this.resource}/categories`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    async fetchMonthlyScreens(params = {}) {
        const response = await axios.get(
            `${this.resource}/screened-by-month`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    async fetchLatestTruePositives(params = {}) {
        const response = await axios.get(
            `${this.resource}/latest-true-positives`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    async fetchRisksAndTasks(params = {}) {
        const response = await axios.get(
            `${this.resource}/risks-and-mitigation-tasks`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    async fetchRecentActivities(params = {}) {
        const response = await axios.get(
            `${this.resource}/recent-activity`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    async fetchHeatmapData(params = {}) {
        const response = await axios.get(
            `${this.resource}/heatmap`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }
}
